var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notfound"}},[_c('h1',[_vm._v("お探しのページは見つかりませんでした。")]),_c('p',[_vm._v(" こちらのURLのページは存在しない、もしくは公開されていません。"),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("ホームへ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }